// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PAzn","label":"styles_label__fzL-i"};